// extracted by mini-css-extract-plugin
export default {"tooltip":"Table_tooltip__G7o9a"};